import Cookies from 'js-cookie';

/**
 * RPGD Cookies manager
 */
(function($) {
  $.RGPDCookies = function(options) {
    const defaults = {
      modal_title: 'Gestion des cookies', // sites.rgpd_cookies_modal_title
      modal_description: 'dépose des cookies pour améliorer votre expérience de navigation, ' + '\n' +
        'mesurer l\'audience du site internet, afficher des publicités personnalisées, ' + '\n' +
        'réaliser des campagnes ciblées et personnaliser l\'interface du site.', // sites.rgpd_cookies_modal_description
      privacy_policy_label: 'Consulter la politique de confidentialité', // sites.rgpd_cookies_privacy_policy_label
      check_all_label: 'Tout cocher', // sites.rgpd_cookies_check_all_label
      refuse_button: 'Refuser', // sites.rgpd_cookies_refuse_button
      settings_button: 'Paramétrer', // sites.rgpd_cookies_settings_button
      accept_button: 'Accepter', // sites.rgpd_cookies_accept_button
      theme: 'default',
      auto_open: false,
    };

    options = $.extend(defaults, options);

    ['site', 'privacy_policy_link', 'cookies'].forEach((option) => {
      if (!options.hasOwnProperty(option)) {
        throw new Error(`${option} option is required`);
      }
    });

    // Any new cookies not answered ?
    let newCookies = false;
    let neverAnswered = true;

    options.cookies.forEach((cookie) => {
      cookie.checked = false;

      if (Cookies.get(`rgpd-cookie-${cookie.slug}`) === undefined) {
        newCookies = true;
      } else {
        neverAnswered = false;
        if (Cookies.get(`rgpd-cookie-${cookie.slug}`) === '1') {
          cookie.checked = true;
        }
      }
    });

    window.RGPDCookies = {
      options,
      newCookies,
      neverAnswered,
      settingsOpened: false,
    };

    window.jsCookie = Cookies;
    // With auto opening, consent has to be an explicit action: nothing is stored until the
    // visitor answers, otherwise the banner would only ever show up on the very first page view.
    if (window.RGPDCookies.neverAnswered && !options.auto_open) {
      options.cookies.forEach((cookie) => {
        Cookies.set(
          `rgpd-cookie-${cookie.slug}`,
          '1',
          {expires: 182},
        );
      });
    }

    /**
     * Dynamic template loading using theme options, use 'default' if not found
     * @param {string} name Template name
     * @return {*} Twig template rendering function
     * @private
     */
    this._loadTemplate = (name) => {
      try {
        return require(`./templates/${name}.${options.theme}.twig`);
      } catch (error) {
        console.warn(`./templates/${name}.${options.theme}.twig not found, using default theme`);
        return require(`./templates/${name}.default.twig`);
      }
    };

    /**
     * Dynamic style loading using theme options, use 'default' if not found
     * @param {string} name Template name
     * @private
     */
    this._loadStyle = (name) => {
      try {
        require(`./sass/${name}.${options.theme}.scss`);
      } catch (error) {
        console.warn(`./sass/${name}.${options.theme}.scss not found, using default theme`);
        require(`./sass/${name}.default.scss`);
      }
    };

    const modalTemplate = this._loadTemplate('modal');
    this._loadStyle('modal');
    $('body').append(modalTemplate(options));

    // Without a single declared cookie, neverAnswered stays true forever: only open when
    // there is actually something to consent to.
    if (options.auto_open && window.RGPDCookies.neverAnswered && options.cookies.length > 0) {
      $('#rgpd-cookies-modal').removeClass('closed');
    }

    $('#cookies').click(() => {
      $('#rgpd-cookies-modal').removeClass('closed');
      $('#rgpd-cookies-modal').removeAttr('style');
      $('#rgpd-cookies-settings').prop('disabled', false);
      $('#rgpd-cookies-modal-cookies').hide();
    });

    $('#open-cookies-modal').click(() => {
      $('#rgpd-cookies-modal').removeClass('closed');
      $('#rgpd-cookies-modal-cookies').hide();
    });

    $('#rgpd-cookies-refuse').click(() => {
      Cookies.remove('rgpd-cookies-google-analytics', {path: ''});
      Cookies.remove('rgpd-cookies-addthis', {path: ''});
      $('#rgpd-cookies-check-all').prop('checked', false);

      options.cookies.forEach((cookie) => {
        $(`#rgpd-cookies-check-${cookie.slug}`).prop('checked', false);
      });

      options.cookies.forEach((cookie) => {
        Cookies.set(`rgpd-cookie-${cookie.slug}`, '0', {expires: 182});
      });

      $('#rgpd-cookies-modal').addClass('closed');
      $('#open-cookies-modal').hide();

      if ('callback' in window.RGPDCookies.options) {
        window.RGPDCookies.options.callback();
      }
    });

    $('#rgpd-cookies-settings').click(() => {
      $('#rgpd-cookies-modal').fadeTo(0, 1);
      $('#rgpd-cookies-modal-cookies').show();
      $('#rgpd-cookies-settings').prop('disabled', true);
      window.RGPDCookies.settingsOpened = true;
    });

    $('#rgpd-cookies-check-all').click(() => {
      if ($('#rgpd-cookies-check-all').is(':checked')) {
        options.cookies.forEach((cookie) => {
          $(`#rgpd-cookies-check-${cookie.slug}`).prop('checked', true);
        });
      } else {
        options.cookies.forEach((cookie) => {
          $(`#rgpd-cookies-check-${cookie.slug}`).prop('checked', false);
        });
      }
    });

    $('#rgpd-cookies-accept').click(() => {
      // Settings not opened and "Accept" clicked ? Assumed that all the checkboxes are checked
      if (!window.RGPDCookies.settingsOpened) {
        $('#rgpd-cookies-check-all').prop('checked', true);

        options.cookies.forEach((cookie) => {
          $(`#rgpd-cookies-check-${cookie.slug}`).prop('checked', true);
        });
      }
      $('#rgpd-cookies-modal').addClass('closed');
      options.cookies.forEach((cookie) => {
        Cookies.set(
          `rgpd-cookie-${cookie.slug}`,
          $(`#rgpd-cookies-check-${cookie.slug}`).is(':checked') ? '1' : '0',
          {expires: 182},
        );
      });
      $('#open-cookies-modal').hide();

      if ('callback' in window.RGPDCookies.options) {
        window.RGPDCookies.options.callback();
      }
    });

    /**
     * When to fade in/out
     * @type {boolean}
     * @private
     */
    this._fadeScrollLimit = 450;

    /**
     * Fading duration
     * @type {number}
     * @private
     */
    this._fadingDuration = 300;

    /**
     * Fading over scroll distance
     * @type {number}
     * @private
     */
    this._fadingDistance = 100;

    // Handle modal button visiblity on scroll
    $(window).on('scroll', () => {
      if ($(window).scrollTop() < this._fadeScrollLimit) {
        $('#rgpd-cookies-modal.closed')
          .stop(true, true)
          .fadeTo(this._fadingDuration, 1);
      } else if (
        $(window).scrollTop() >= this._fadeScrollLimit &&
        $(window).scrollTop() < (this._fadeScrollLimit + this._fadingDistance)) {
        $('#rgpd-cookies-modal.closed')
          .stop(true, true)
          .fadeTo(this._fadingDuration, 1 - ($(window).scrollTop() - this._fadeScrollLimit) / this._fadingDistance);
      } else {
        $('#rgpd-cookies-modal.closed')
          .stop(true, true)
          .fadeTo(this._fadingDuration, 0);
      }
    });

    // On page reload, scroll is not 0
    if ($(window).scrollTop() >= this._fadeScrollLimit) {
      $('#rgpd-cookies-modal.closed').hide();
    } else {
      $('#rgpd-cookies-modal.closed').show();
    }
  };
})(jQuery);
